import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalonesService {

  salonesURL = environment.apiURL+'sgc/salones';

  constructor(private http:HttpClient) {}

  getSalones(): Observable<any>{
    const url = this.salonesURL;
    return this.http.get<any[]>(url);
   }
}
